import { render, staticRenderFns } from "./CooperaDetail.vue?vue&type=template&id=02dc94c0&scoped=true&"
import script from "./CooperaDetail.vue?vue&type=script&lang=js&"
export * from "./CooperaDetail.vue?vue&type=script&lang=js&"
import style0 from "./CooperaDetail.vue?vue&type=style&index=0&id=02dc94c0&scoped=true&lang=less&"
import style1 from "./CooperaDetail.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02dc94c0",
  null
  
)

export default component.exports